import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generic filter pipe (replacement for ng2-search-filter).
 * Usage: | filter:searchText  or  | filter:searchText:'fieldName'
 */
@Pipe({
  standalone: false,
  name: 'filter'
})
export class FilterListPipe implements PipeTransform {
  transform(value: any[], searchText?: string, field?: string): any[] {
    if (!value || !Array.isArray(value)) return [];
    if (searchText == null || searchText === undefined) return value;

    const search = String(searchText).trim().toLowerCase();
    if (search === '') return value;

    return value.filter((item) => {
      try {
        if (field != null && field !== '') {
          const prop = item?.[field];
          return prop != null && String(prop).toLowerCase().includes(search);
        }
        return JSON.stringify(item).toLowerCase().includes(search);
      } catch {
        return false;
      }
    });
  }
}
